import styled from "styled-components/macro";

export const CoverRoot = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 2 / 3;
  container-type: inline-size;
  overflow: hidden;
  isolation: isolate;
  background-color: var(--menu-color-fullscreen);

  .cover-shine {
    position: absolute;
    inset: 0;
    z-index: 3;
    pointer-events: none;
    opacity: 0;
    background: linear-gradient(105deg, transparent 35%, rgba(255, 255, 255, 0.38) 50%, transparent 65%);
    background-size: 300% 100%;
    background-position: 130% 0;
    transition: opacity 150ms ease-in-out;
  }

  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 22px -6px rgba(0, 0, 0, 0.38);

  &::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 0;
    width: 10%;
    z-index: 2;
    pointer-events: none;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.12) 0%,
      rgba(255, 255, 255, 0.12) 28%,
      rgba(0, 0, 0, 0.38) 40%,
      rgba(0, 0, 0, 0.08) 54%,
      rgba(255, 255, 255, 0.24) 66%,
      rgba(255, 255, 255, 0.05) 84%,
      transparent 100%
    );
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 2;
    pointer-events: none;
    border-radius: inherit;
    background:
      linear-gradient(to bottom, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.02) 7%, transparent 14%, transparent 86%, rgba(0, 0, 0, 0.025) 93%, rgba(0, 0, 0, 0.07)),
      linear-gradient(to left, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.025) 6%, transparent 12%),
      linear-gradient(135deg, rgba(255, 255, 255, 0.14), transparent 40%, rgba(0, 0, 0, 0.06));
  }

  &.has-image .cover-image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &:not(.has-image) {
    background-image: linear-gradient(160deg, var(--menu-color-fullscreen), var(--menu-color-fullscreen-hover));

    &::after {
      background:
        linear-gradient(to bottom, rgba(0, 0, 0, 0.03), transparent 10%, transparent 90%, rgba(0, 0, 0, 0.035)),
        linear-gradient(to left, rgba(0, 0, 0, 0.04), transparent 8%),
        linear-gradient(135deg, rgba(255, 255, 255, 0.14), transparent 40%, rgba(0, 0, 0, 0.06));
    }

    .cover-page {
      position: absolute;
      inset: 0;
      padding: 13cqw 12cqw;
      display: flex;
      flex-direction: column;
      gap: 4.2cqw;
    }

    .cover-page-head {
      display: flex;
      align-items: flex-start;
      gap: 5cqw;
    }

    .cover-drop-cap {
      flex: none;
      font-family: "GT Super Display", serif;
      font-size: 40cqw;
      line-height: 0.8;
      padding-top: 2.5cqw;
      color: color-mix(in srgb, var(--grey-1) 50%, transparent);
    }

    .cover-page-head-lines {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4.2cqw;
      padding-top: 5cqw;
    }

    .cover-line {
      height: 2.2cqw;
      min-height: 1px;
      border-radius: 99px;
      background: color-mix(in srgb, var(--grey-1) 26%, transparent);
    }
  }

  &.tinted:not(.has-image) {
    background-color: var(--cover-tint);
    background-image: linear-gradient(160deg, rgba(255, 255, 255, 0.1), rgba(0, 0, 0, 0.06));

    .cover-page.titled .cover-title {
      color: var(--cover-ink);
    }

    .cover-page.titled .cover-line {
      background: color-mix(in srgb, var(--cover-ink) 35%, transparent);
    }
  }

  &:not(.has-image) .cover-page.titled {
    padding: 11cqw 10cqw;
    gap: 6cqw;
    justify-content: flex-start;

    .cover-title {
      font-family: "GT Super Display", serif;
      font-size: 15cqw;
      line-height: 1.1;
      color: color-mix(in srgb, var(--grey-0) 90%, transparent);
      margin-bottom: 3cqw;
      overflow: hidden;
      overflow-wrap: anywhere;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      line-clamp: 4;
    }
  }

  &:not(.has-image):not(.tinted) .cover-page.titled .cover-title {
    -webkit-line-clamp: 5;
    line-clamp: 5;
  }

  &.mini {
    border-radius: 1px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  &.mini:not(.has-image) {
    .cover-page {
      padding: 15% 14%;
    }

    .cover-page {
      gap: 2px;
    }

    .cover-page-head-lines,
    .cover-line:nth-child(n + 5) {
      display: none;
    }

    .cover-line {
      height: 1px;
    }

    .cover-drop-cap {
      font-size: 50cqw;
    }
  }

  &:hover .cover-shine,
  &.shine-active .cover-shine {
    opacity: 1;
    background-position: -30% 0;
    transition: opacity 150ms ease-in-out, background-position 800ms ease-in-out;
  }

  @media (prefers-reduced-motion: reduce) {
    .cover-shine {
      display: none;
    }
  }
`;
